import React, { Component, Dispatch } from 'react';
import Input from '../../../../components/input/text/input-formik';
import { Log } from 'ng2-logger';
import Translator from '../../../../core/i18n';
import { Confirm, Notification } from '../../../../components/notification/main';
import { Common } from '../../../../core/common';
import { IQuestionList, ISurveyActivityQuestionsProps } from '../../../../models/components/add-activity-survey-questions';
import { IAction, IAppState } from '../../../../models/action/core';
import { connect } from 'react-redux';
import { Formik, FormikProps, getIn } from 'formik';
import { ISurveyInfo } from '../../../../models/action/survey';
import { Choice } from './questionTypes/choice';
import { Header } from './questionTypes/header';
import { Paragraph } from './questionTypes/paragraph';
import { OpenEnded } from './questionTypes/openended';
import { Matris } from './questionTypes/matris';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { SurveyQuestionType } from '../../../../models/enums/SurveyQuestionType';
import ReactDOM from 'react-dom';
import { Guid } from 'guid-typescript';
import * as Actions from '../../../../store/actions/survey';
import imgAnn from '../../../../static/images/announcement.svg';

const T = Translator.create();
const _logger = Log.create('profile-tabpanel');
let _common: Common;

interface ISurveyActivityQuestionsState {
    initialValues: ISurveyInfo;
    questionCategories: IQuestionCategories[];
    grid: number;
    questionList: IQuestionList[];
    questionListPadding: string | number;
}

interface IQuestionCategories {
    questionType: SurveyQuestionType;
    icon: string;
    text: string;
}

const portal = document.createElement('div');
document.body.appendChild(portal);

export class SurveyActivityQuestions extends Component<ISurveyActivityQuestionsProps, ISurveyActivityQuestionsState> {
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
            initialValues: { ...this.props.surveyInfo },
            questionCategories: [
                { questionType: SurveyQuestionType.Matrix, icon: 'matris', text: T.t('r_survey_matrix_questions') },
                { questionType: SurveyQuestionType.Heading, icon: 'header', text: T.t('r_survey_header') },
                { questionType: SurveyQuestionType.Paragraph, icon: 'paragraph', text: T.t('r_survey_paragraph_questions') },
                { questionType: SurveyQuestionType.SingleChoice, icon: 'singlechoice', text: T.t('r_survey_single_choice_questions') },
                { questionType: SurveyQuestionType.MultipleChoice, icon: 'multichoice', text: T.t('r_survey_multi_choice_questions') },
                // { questionType: SurveyQuestionType.OpenEndedOneLine },
                { questionType: SurveyQuestionType.OpenEndedTextArea, icon: 'paragraph', text: T.t('r_survey_openended_questions') }
            ],
            questionList:
                this.props.surveyInfo && this.props.surveyInfo.questionList && this.props.surveyInfo.questionList.length
                    ? this.props.surveyInfo.questionList
                    : [],
            grid: 8,
            questionListPadding: '2em'
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidUpdate(prevProps: ISurveyActivityQuestionsProps) {
        if (prevProps.onSubmit !== this.props.onSubmit) {
            const _initialValues = this.state.initialValues;
            _initialValues.questionList = this.state.questionList;
            this.setState({ initialValues: _initialValues });
            this.onSubmit(_initialValues);
        }

        if (prevProps.surveyInfo !== this.props.surveyInfo) {
            this.setState({ initialValues: this.props.surveyInfo });
        }
    }

    onSubmit = (values: ISurveyInfo) => {

        if(this.state.questionList.length<1)
        {
            Notification.setNotification('error', T.t('r_survey_question_error'), 'topRight');
            this.props.onChangeDisabled(false);
        }
        else if (this.state.questionList.find(q => ((q.questionType === SurveyQuestionType.Heading) && !q.description))) {
            Notification.setNotification('error', T.t('r_survey_title_name_entered'), 'topRight');
            this.props.onChangeDisabled(false);
        } else if (this.state.questionList.find(q => ((q.questionType === SurveyQuestionType.OpenEndedTextArea) && !q.description))) {
            Notification.setNotification('error', T.t('r_survey_open_ended_text_area_name_entered'), 'topRight');
            this.props.onChangeDisabled(false);
        } else if (this.state.questionList.find(q => ((q.questionType === SurveyQuestionType.Paragraph) && !q.description))) {
            Notification.setNotification('error', T.t('r_survey_description_entered'), 'topRight');
            this.props.onChangeDisabled(false);
        } else if (
            this.state.questionList.find(q =>
                (q.questionType === SurveyQuestionType.SingleChoice || q.questionType === SurveyQuestionType.MultipleChoice) &&
                (!q.description))) {
            Notification.setNotification('error', T.t('r_survey_question_text_entered'), 'topRight');
            this.props.onChangeDisabled(false);
        } else if (
            this.state.questionList.find(q =>
                (q.questionType === SurveyQuestionType.SingleChoice || q.questionType === SurveyQuestionType.MultipleChoice) &&
                (!q.questionChoices || (q.questionChoices && !q.questionChoices.length)))) {
            Notification.setNotification('error', T.t('r_survey_question_least_option'), 'topRight');
            this.props.onChangeDisabled(false);
        } else if (
            this.state.questionList.find(q =>
                (q.questionType === SurveyQuestionType.SingleChoice || q.questionType === SurveyQuestionType.MultipleChoice) &&
                (q.questionChoices && q.questionChoices.findIndex(qc => !qc.text) !== -1))) {
            Notification.setNotification('error', T.t('r_survey_stylish_text_entered'), 'topRight');
            this.props.onChangeDisabled(false);
        } else {
            this.props.dispatch(
                Actions.getEditSurveyInfo(this.props.surveyData, values, undefined, undefined, this.props.callBackFunction)
            );
        }
    };

    onFormikSubmit = (FormikValues: ISurveyInfo) => {
        const values: ISurveyInfo = JSON.parse(JSON.stringify(FormikValues));
        values.questionList = this.state.questionList;
        this.onSubmit(values);
    };

    reorder = (startIndex: number, endIndex: number) => {
        const _questionList = this.state.questionList.sort((a, b) => a.displayOrder - b.displayOrder);
        const sourceItem = _questionList.find(q => q.displayOrder === startIndex);
        const sourceItemIndex = _questionList.findIndex(q => q.displayOrder === startIndex);
        const endItem = _questionList.find(q => q.displayOrder === endIndex);

        if (sourceItem) {
            _questionList.splice(sourceItemIndex, 1);
            const amount = sourceItem.matrixQuestions && sourceItem.matrixQuestions.length ? sourceItem.matrixQuestions.length : 1;

            if (sourceItem.displayOrder < endIndex) {
                _questionList
                    .filter(q => q.displayOrder <= endIndex && q.displayOrder > startIndex).forEach(element => element.displayOrder = element.displayOrder - amount);
            } else if (sourceItem.displayOrder > endIndex) {
                _questionList
                    .filter(q => q.displayOrder < startIndex && q.displayOrder >= endIndex).forEach(element => element.displayOrder = element.displayOrder + amount);
            }

            if (endItem && endItem.matrixQuestions && endItem.matrixQuestions.length && endItem.displayOrder > startIndex) {
                sourceItem.displayOrder = endIndex + (endItem.matrixQuestions.length - 1);
            } else {
                if (sourceItem && sourceItem.matrixQuestions && sourceItem.matrixQuestions.length && sourceItem.displayOrder < endIndex) {
                    sourceItem.displayOrder = endIndex - (sourceItem.matrixQuestions.length - 1);
                } else {
                    sourceItem.displayOrder = endIndex;
                }
            }
            _questionList.push(sourceItem);
            this.setState({ questionList: _questionList });
        }
    };

    copy = (endIndex: number, type: string, onlyWrap?: boolean) => {
        const _questionList = this.state.questionList.sort((a, b) => a.displayOrder - b.displayOrder);
        _questionList.filter(q => q.displayOrder >= endIndex).forEach(q => q.displayOrder = q.displayOrder + 1);
        if (!onlyWrap) {
            const item: IQuestionList = {
                surveyQuestionId: '0',
                questionType: this.getQuestionType(type),
                displayOrder: endIndex,
                description: '',
                groupId: type === 'Matrix' ? Guid.create().toString() : '',
                matrixQuestions:
                    type === 'Matrix' ? [{ surveyQuestionId: '0', displayOrder: endIndex, description: T.t('r_row') + ' 1' }] : undefined,
                questionChoices: type === 'Matrix' ? [{ surveyQuestionChoiceId: '0', displayOrder: 0, text: T.t('r_column') + ' 1' }] : undefined
            };
            _questionList.push(item);
        }
        this.setState({ questionList: _questionList });
    };

    add = (type: string) => {
        let endIndex = 1;
        if (this.state.questionList.length > 0) {
            endIndex = this.state.questionList.sort((a, b) => b.displayOrder - a.displayOrder)[0].displayOrder + 1;
        }

        this.copy(endIndex, type);
    };

    getQuestionType = (type: string): SurveyQuestionType => {
        switch (type) {
            case SurveyQuestionType[SurveyQuestionType.Heading]:
                return SurveyQuestionType.Heading;
            case SurveyQuestionType[SurveyQuestionType.Matrix]:
                return SurveyQuestionType.Matrix;
            case SurveyQuestionType[SurveyQuestionType.MultipleChoice]:
                return SurveyQuestionType.MultipleChoice;
            case SurveyQuestionType[SurveyQuestionType.Paragraph]:
                return SurveyQuestionType.Paragraph;
            case SurveyQuestionType[SurveyQuestionType.SingleChoice]:
                return SurveyQuestionType.SingleChoice;
            case SurveyQuestionType[SurveyQuestionType.OpenEndedTextArea]:
                return SurveyQuestionType.OpenEndedTextArea;
            default:
                return SurveyQuestionType.Heading;
        }
    };

    onDragEnd = (result: any) => {
        this.setState({ questionListPadding: '2em' });

        const res = result;
        if (!res.destination) {
            return;
        }

        const sourceItem = this.state.questionList[res.source.index];
        const destinationItem = this.state.questionList[res.destination.index];

        if (res.source.droppableId === res.destination.droppableId && sourceItem && destinationItem) {
            this.reorder(sourceItem.displayOrder, destinationItem.displayOrder);
        }

        if (res.source.droppableId.startsWith('types')) {
            if (destinationItem) {
                this.copy(destinationItem.displayOrder, res.draggableId);
            } else {
                this.add(res.draggableId);
            }
        }
    };

    PortalAwareItem = (provided: any, snapshot: any, item: IQuestionCategories) => {
        const usePortal = snapshot.isDragging;

        const child =
            (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className="col-lg-12 col-sm-12 survey-type sub-type"
                >
                    <div className="type-title-little">
                        <div className="type-icon">
                            <img src={_common.GetDefaultIcons(item.icon)} alt="" />
                        </div>
                        <span className="type-title-text-little">{item.text}</span>
                        <a
                            className="survey_type_add_btn_2"
                            id="add_btn_top"
                            onClick={this.add.bind(this, SurveyQuestionType[item.questionType])}
                        >
                            <i className="material-icons">add</i>
                        </a>
                    </div>
                </div>
            );

        if (!usePortal) {
            return child;
        }

        // if dragging - put the item in a portal
        return ReactDOM.createPortal(child, portal);
    };

    DeleteQuestion = (displayOrder: number, onlyWrap?: boolean, deleteMessage?: any) => {
            Confirm.setConfirm(
                'normal',
                () => this.DeleteConfirmed(displayOrder, onlyWrap),
                deleteMessage ? deleteMessage : T.t('r_delete_survey_question'),
                null,
                null,
                undefined,
                true
            );
    };

    DeleteConfirmed = (displayOrder: number, onlyWrap?: boolean) => {
        const _questionList = this.state.questionList.sort((a, b) => a.displayOrder - b.displayOrder);
            if (onlyWrap) {
                _questionList.filter(q => q.displayOrder > displayOrder).forEach(q => q.displayOrder = q.displayOrder - 1);
                this.setState({ questionList: _questionList });
            } else {
                const sourceItemIndex = _questionList.findIndex(q => q.displayOrder === displayOrder);
                const sourceItem = _questionList.find(q => q.displayOrder === displayOrder);

                if (sourceItem && sourceItemIndex !== -1) {
                    const amount = sourceItem.matrixQuestions && sourceItem.matrixQuestions.length ? sourceItem.matrixQuestions.length : 1;

                    _questionList.splice(sourceItemIndex, 1);
                    _questionList.filter(q => q.displayOrder >= displayOrder).forEach(q => q.displayOrder = q.displayOrder - amount);
                    this.setState({ questionList: _questionList });
                }
            }
    };

    EditQuestion = (question: IQuestionList) => {
        const _questionList = this.state.questionList.sort((a, b) => a.displayOrder - b.displayOrder);
        if (_questionList.length > 0) {
            const sourceItemIndex = _questionList.findIndex(q => q.displayOrder === question.displayOrder);
            if (sourceItemIndex !== -1) {
                _questionList.splice(sourceItemIndex, 1);
                _questionList.push(question);
                this.setState({ questionList: _questionList });
            }
        }
    };

    QuestionsPortalAwareItem = (provided: any, snapshot: any, item: IQuestionList, index: number) => {
        const usePortal = snapshot.isDragging;
        let child;
        switch (item.questionType) {
            case SurveyQuestionType.Heading:
                child = (
                    <React.Fragment>
                        <div id={'questions_' + index} ref={provided.innerRef} {...provided.draggableProps}>
                            <div className="row seperator" style={{justifyContent: "space-between"}}>
                                <Header
                                    editQuestion={this.EditQuestion}
                                    question={item}
                                    deleteQuestion={this.DeleteQuestion}
                                    dragHandleProps={provided.dragHandleProps}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                );
                break;
            case SurveyQuestionType.Paragraph:
                child = (
                    <React.Fragment>
                        <div id={'questions_' + index} ref={provided.innerRef} {...provided.draggableProps}>
                            <div className="row seperator"  style={{justifyContent: "space-between"}}>
                                <Paragraph
                                    editQuestion={this.EditQuestion}
                                    question={item}
                                    deleteQuestion={this.DeleteQuestion}
                                    dragHandleProps={provided.dragHandleProps}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                );
                break;
            case SurveyQuestionType.Matrix:
                child = (
                    <React.Fragment>
                        <div id={'questions_' + index} ref={provided.innerRef} {...provided.draggableProps}>
                            <div className="row seperator" style={{ position: 'relative', justifyContent: "space-between" }}>
                                <Matris
                                    copy={this.copy}
                                    baseDisplayOrder={item.displayOrder}
                                    editQuestion={this.EditQuestion}
                                    question={item}
                                    deleteQuestionConfirm={this.DeleteConfirmed}
                                    deleteQuestion={this.DeleteQuestion}
                                    dragHandleProps={provided.dragHandleProps}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                );
                break;
            case SurveyQuestionType.MultipleChoice:
                child = (
                    <React.Fragment>
                        <div id={'questions_' + index} ref={provided.innerRef} {...provided.draggableProps}>
                            <div className="row seperator"  style={{justifyContent: "space-between"}}>
                                <Choice
                                    editQuestion={this.EditQuestion}
                                    question={item}
                                    deleteQuestion={this.DeleteQuestion}
                                    dragHandleProps={provided.dragHandleProps}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                );
                break;
            case SurveyQuestionType.SingleChoice:
                child = (
                    <React.Fragment>
                        <div id={'questions_' + index} ref={provided.innerRef} {...provided.draggableProps}>
                            <div className="row seperator"  style={{justifyContent: "space-between"}}>
                                <Choice
                                    editQuestion={this.EditQuestion}
                                    question={item}
                                    deleteQuestion={this.DeleteQuestion}
                                    dragHandleProps={provided.dragHandleProps}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                );
                break;
            case SurveyQuestionType.OpenEndedTextArea:
                child = (
                    <React.Fragment>
                        <div id={'questions_' + index} ref={provided.innerRef} {...provided.draggableProps}>
                            <div className="row seperator"  style={{justifyContent: "space-between"}}>
                                <OpenEnded
                                    editQuestion={this.EditQuestion}
                                    question={item}
                                    deleteQuestion={this.DeleteQuestion}
                                    dragHandleProps={provided.dragHandleProps}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                );
                break;
            default:
                break;
        }

        if (!usePortal) {
            return child;
        }

        return ReactDOM.createPortal(child, portal);
    };

    onDragStart = (result: any) => {
        if (result.source.droppableId === 'questions') {
            const item = document.getElementById('questions_' + result.source.index);
            if (item) {
                this.setState({ questionListPadding: item.clientHeight + 50 });
            }
        } else {
            this.setState({ questionListPadding: '200px' });
        }
    };

    onChangeName = (e: any, formik: FormikProps<ISurveyInfo>) => {
        if (e && e.target) {
            const _initialValues = this.state.initialValues;
            _initialValues.name = e.target.value;
            this.setState({ initialValues: _initialValues });
        }
    };

    public render() {
        return (
            <div
                className={'survey-questionstab tab-pane fade' + (this.props.currentTab === '_questionsTab' ? ' show active' : '')}
                style={{ display: this.props.currentTab === '_questionsTab' ? 'block' : 'none', width: '96.44vw' }}
                id="survey-questions"
                role="tabpanel"
                aria-labelledby="survey-questions-tab"
            >
                <Formik
                    initialValues={this.state.initialValues}
                    onSubmit={this.onFormikSubmit}
                >
                    {formik => {
                        return (
                            <form onSubmit={formik.handleSubmit} key={'project_add_user_modal'}>
                                <div className="row mt-0">
                                    <DragDropContext onDragEnd={this.onDragEnd} onDragStart={this.onDragStart}>
                                        <div className=" col-md-3">
                                            <div className="row survey-categories mt-0">
                                                {this.state.questionCategories.map((q, index) => (
                                                    <Droppable
                                                        key={index}
                                                        droppableId={'types_' + SurveyQuestionType[q.questionType]}
                                                        isDropDisabled={true}
                                                    >
                                                        {(_provided, _snapshot) => (
                                                            <div
                                                                ref={_provided.innerRef}
                                                                className='col-6'
                                                            >
                                                                <Draggable
                                                                    key={SurveyQuestionType[q.questionType]}
                                                                    draggableId={SurveyQuestionType[q.questionType]}
                                                                    index={index}
                                                                >
                                                                    {(provided, snapshot) => (
                                                                        <React.Fragment>
                                                                            {this.PortalAwareItem(provided, snapshot, q)}
                                                                            {snapshot.isDragging &&
                                                                                (q.questionType === SurveyQuestionType.Matrix ? (
                                                                                    <div
                                                                                        className="col-12 survey-type type-matris"
                                                                                        style={{ display: 'none !important' }}
                                                                                    >
                                                                                        <div className="type-title-little">
                                                                                            <div className="type-icon mr-2">
                                                                                                <img
                                                                                                    src={_common.GetDefaultIcons(q.icon)}
                                                                                                    alt=""
                                                                                                />
                                                                                            </div>
                                                                                            <span className="type-title-text-little">
                                                                                                {q.text}
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                ) : (
                                                                                    <div
                                                                                        className="col-lg-12 col-sm-12 survey-type sub-type"
                                                                                        style={{ display: 'none !important' }}
                                                                                    >
                                                                                        <div className="type-title-little">
                                                                                            <div className="type-icon">
                                                                                                <img
                                                                                                    src={_common.GetDefaultIcons(q.icon)}
                                                                                                    alt=""
                                                                                                />
                                                                                            </div>
                                                                                            <span className="type-title-text-little">
                                                                                                {q.text}
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                ))}
                                                                        </React.Fragment>
                                                                    )}
                                                                </Draggable>
                                                            </div>
                                                        )}
                                                    </Droppable>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="col-md-9" style={{ paddingRight: 0 }}>
                                            <Droppable droppableId="questions">
                                                {(_provided, _snapshot) => (
                                                    <div
                                                        style={{ paddingBottom: this.state.questionListPadding }}
                                                        ref={_provided.innerRef}
                                                        className="survey-details"
                                                    >
                                                        <div className="row seperator"  style={{justifyContent: "space-between"}}>
                                                            <div className="w-85 pl-0">
                                                                <div className="survey_name survey_input_padding">
                                                                    <Input
                                                                        onChange={this.onChangeName}
                                                                        type={'text'}
                                                                        name={'name'}
                                                                        placeHolder={T.t('r_activity_survey_name_placeholder')}
                                                                        value={this.state.initialValues !== undefined && this.state.initialValues !== null && this.state.initialValues.name !== undefined && this.state.initialValues.name !== null ? this.state.initialValues.name : ''}
                                                                        formik={formik} />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div>
                                                            {this.state.questionList.length > 0 ?
                                                                this.state.questionList
                                                                    .sort((a, b) => a.displayOrder - b.displayOrder)
                                                                    .map((q, index) => (
                                                                        <Draggable key={index} draggableId={index.toString()} index={index}>
                                                                            {(provided, snapshot) => (
                                                                                <React.Fragment>
                                                                                    {this.QuestionsPortalAwareItem(
                                                                                        provided,
                                                                                        snapshot,
                                                                                        q,
                                                                                        index
                                                                                    )}
                                                                                </React.Fragment>
                                                                            )}
                                                                        </Draggable>
                                                                    ))
                                                                :
                                                                <div className="d-flex flex-column align-items-center pt-5">
                                                                    <img style={{ minWidth: '350px' }} src={imgAnn} />
                                                                    <h5 className='d-block' style={{ marginTop: 15, textAlign: 'center', marginBottom: 50 }}>
                                                                        {T.t('r_gen_create_survey_choosing_panel_left')}
                                                                    </h5>
                                                                </div>}
                                                        </div>
                                                    </div>
                                                )}
                                            </Droppable>
                                        </div>
                                    </DragDropContext>
                                </div>
                            </form>
                        );
                    }}
                </Formik>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ISurveyActivityQuestionsProps): ISurveyActivityQuestionsProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: ISurveyActivityQuestionsProps = Object.assign({}, ownProps, {
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId
    });

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CSurveyActivityQuestions = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(SurveyActivityQuestions);

export default CSurveyActivityQuestions;
